mutation RemoveQAAnnotationCommentOnComputedDeliverable($commentId: ID!) {
    removeQAAnnotationCommentOnComputedDeliverable(commentId: $commentId) {
        _id
    }
}
